/**
 * Dato draft content requires the GraphQL /preview endpoint (see lib/api.js).
 * Next.js sets context.preview after /api/preview/preview; Vercel Preview sets VERCEL_ENV=preview.
 *
 * @param {{ preview?: boolean } | undefined} context
 * @returns {boolean}
 */
export function isDatoPreview(context) {
  return Boolean(context?.preview) || process.env.VERCEL_ENV === "preview";
}
